function capitalize(str) {
  return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}

const appName = process.env.MIX_APP_NAME;

// prettier-ignore
const message = {
  form: {
    enter: "Enter {attribute}",
    inputValidPhone: "Please input valid country code and number",
    select: "Select {attribute}",
    fillRequired: "Please select or fill in required field to continue",
    uploadFileInstr: "Click to browse or drop your file here",
    fileReadyToSend: "File ready to send",
    selectSuggestion: "Select from suggestion list",
    clickInputContactInfo: "Click to input contact information",
  },
  alert: {
    validationFailed: "Validation failed",
    inputFieldWarning: "Please input your valid account information in each field",
    accept: "OK, I understand",
  },
  day: {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
  },
  validation: {
    messages: {
      _default: "The {0} value is not valid",
      after: "The {0} must be after {1} or equal to {2}",
      alpha: "The {0} field may only contain alphabetic characters",
      alpha_dash: "The {0} field may contain alpha-numeric characters as well as dashes and underscores",
      alpha_num: "The {0} field may only contain alpha-numeric characters",
      alpha_spaces: "The {0} field may only contain alphabetic characters as well as spaces",
      before: "The {0} must be before {1} or equal to {2}",
      between: "The {0} field must be between {1} and {2}",
      confirmed: "The {0} confirmation does not match",
      credit_card: "The {0} field is invalid",
      date_between: "The {0} must be between {1} and {2}",
      date_format: "The {0} must be in the format {format}",
      decimal: "The {0} field must be numeric and may contain decimal points",
      digits: "The {0} field must be numeric and contains exactly {1} digits",
      dimensions: "The {0} field must be {1} pixels by {2} pixels",
      email: "The {0} field must be a valid email",
      excluded: "The {0} field must be a valid value",
      ext: "The {0} field must be a valid file",
      image: "The {0} field must be an image",
      included: "The {0} field must be a valid value",
      integer: "The {0} field must be an integer",
      ip: "The {0} field must be a valid ip address",
      ip_or_fqdn: "The {0} field must be a valid ip address or FQDN",
      length: "The {0} length must be between {1} and {2}",
      max: "The {0} field may not be greater than {1} characters",
      max_value: "The {0} field must be {1} or less",
      mimes: "The {0} field must have a valid file type",
      min: "The {0} field must be at least {1} characters",
      min_value: "The {0} field must be {1} or more",
      numeric: "The {0} field may only contain numeric characters",
      regex: "The {0} field format is invalid",
      required: "The {0} field is required",
      required_if: "The {0} field is required when the {1} field has this value",
      size: "The {0} size must be less than {1}",
      url: "The {0} field is not a valid URL",
    },
  },
  attribute: {
    account: "Account",
    additionalAddress: "Additional Address",
    addon: "Addon",
    address: "Address",
    addressBook: "Address Book",
    addressSuggestion: "Address Suggestion",
    addressDetail: "Address Detail (e.g Street Name)",
    addressUnit: "Address Unit",
    ago: "Ago",
    airWaybill: "Air Waybill",
    all: "All",
    appearance: "Appearance",
    applicationDisplay: "Application Display",
    article: "Article",
    bankTransfer: "Bank Transfer",
    bulkOrder: "Bulk Order",
    calculator: "Calculator",
    cardNumber: "Card Number",
    cardPayment: "Card Payment",
    category: "Category",
    checkout: "Checkout",
    city: "City",
    companyName: "Company Name",
    companyIndividualName: "Company / Individual Name",
    contactInformation: "Contact Information",
    country: "Country",
    coupon: "Coupon",
    creditCard: "Credit Card",
    currency: "Currency",
    customer: "Customer",
    customerReferenceNumber: "Customer Reference Number",
    darkMode: "Dark Mode",
    dashboard: "Dashboard",
    dateAtt: "{0} Date",
    day: "Day | Days",
    debitCard: "Debit Card",
    description: "Description",
    delivery: "Delivery",
    deliveryAfter: "Delivery After",
    deliveryBefore: "Delivery Before",
    deliveryDate: "Delivery Date",
    deliveryPartner: "Delivery Partner",
    deliveryType: "Delivery Type",
    deliverySetting: "Delivery Setting",
    detail: "Detail",
    dimension: "Dimension",
    district: "District",
    driver: "Driver",
    driverTip: "Tip Driver",
    dropoff: "Dropoff",
    email: "Email",
    emailOrPhone: "Email or Phone Number",
    endDate: "End Date",
    estimation: "Estimation",
    favorite: "Favorite",
    file: "File",
    filterOption: "Filter Options",
    firstName: "First Name",
    fragile: "Fragile",
    goodType: "Good Type",
    grossWeightPerItem: "Gross Weight per Item",
    handbook: "Handbook",
    height: "Height",
    helpCenter: "Help Center",
    hour: "Hour | Hours",
    image: "image",
    imageProof: "Image Proof",
    instruction: "Instruction",
    invoice: "Invoice",
    invoiceAtt: "Invoice {0}",
    item: "Item",
    itemContent: "Item Content",
    itemValue: "Item Value",
    keyword: "Keyword",
    language: "Language",
    lastName: "Last Name",
    lastUpdated: "Last Updated",
    length: "Length",
    liveChat: "Live Chat",
    location: "Location",
    measurementUnit: "Measurement Unit",
    message: "Message",
    minute: "Minute | Minutes",
    month: "Month",
    name: "Name",
    new: "New",
    newPassword: "New Password",
    nettWeightPerWeight: "Nett Weight per Item",
    note: "Note",
    notification: "Notification",
    number: "Number",
    oldPassword: "Old Password",
    optimization: "Optimization",
    option: "Option",
    optional: "Optional",
    or: "Or",
    order: "Order",
    orderNumber: "Order Number",
    orderStatus: "Order Status",
    package: "Package",
    password: "Password",
    passwordConfirmation: "Password Confirmation",
    payment: "Payment",
    paymentMethod: "Payment Method",
    paymentOption: "Payment Option",
    paymentTerm: "Payment Term",
    personalInfo: "Personal Info",
    phoneNumber: "Phone Number",
    pickup: "Pickup",
    pickupAfter: "Pickup After",
    pickupBefore: "Pickup Before",
    pickupDate: "Pickup Date",
    postalCode: "Postal Code",
    postPaid: "Post Paid",
    preference: "Preference",
    preferredState: "Preferred State",
    price: "Price",
    priceChange: "Price Change",
    priceDetail: "Price Detail",
    priceRate: "Rate",
    profile: "profile",
    progress: "Progress",
    promoCode: "Promo Code",
    province: "Province",
    purpose: "Purpose",
    quantity: "Quantity",
    receipt: "Receipt",
    receiver: "Receiver",
    receiverAtt: "Receiver {0}",
    remark: "Remark",
    requestCollectionBefore: "Request Collection Before",
    requestPickupTime: "Request Pickup Time",
    result: "Result",
    roundTrip: "Round Trip",
    route: "Route",
    savedAddress: "Saved Address",
    savedCC: "Saved Credit Card",
    scheduledDate: "Scheduled Date",
    scheduledOrder: "Scheduled Order",
    scheduledTime: "Scheduled Time",
    second: "Second | Seconds",
    sender: "Sender",
    senderAtt: "Sender {0}",
    serviceType: "Service Type",
    setting: "Setting",
    settingResource: "Setting & Resource",
    size: "Size",
    shipment: "Shipment",
    shipmentAtt: "Shipment {0}",
    signatureTitle: "Signature Title",
    signatureName: "Signature Name",
    startDate: "Start Date",
    state: "State",
    step: "Step {0}",
    subdistrict: "Subdistrict",
    subject: "Subject",
    summary: "Summary",
    termCondition: "Terms & Condition",
    time: "Time",
    timeSlot: "Time Slot",
    tool: "Tool",
    topUpPackage: "Top-up Package",
    topUpTransferRequest: "Top-up Transfer Request",
    totalPrice: "Total Price",
    totalGrossWeight: "Gross Weight",
    totalNettWeight: "Nett Weight",
    trackingHistory: "Tracking History",
    transaction: "Transaction",
    transactionType: "Transaction Type",
    wallet: "Wallet",
    walletTopUp: "Wallet Top-up",
    warning: "Warning",
    waybill: "Waybill",
    waybillLogo: "Waybill Logo",
    weight: "Weight",
    width: "Width",
    unit: "Unit",
    userSetting: "User Setting",
    value: "Value",
    vehicle: "Vehicle",
    vehicleType: "Vehicle Type",
    year: "Year | Years",
  },
  action: {
    accept: "Accept",
    add: "Add",
    addAtt: "Add {0}",
    apply: "Apply",
    applyAtt: "Apply {0}",
    applyPromoCode: "Apply Promo Code",
    back: "Back",
    calculate: "Calculate",
    calculating: "Calculating",
    cancel: "Cancel",
    change: "Change",
    clear: "Clear",
    close: "Close",
    confirm: "Confirm",
    contactUs: "Contact Us",
    continue: "Continue",
    copy: "Copy",
    create: "Create",
    createAtt: "Create {0}",
    delete: "Delete",
    download: "Download",
    downloadAtt: "Download {0}",
    downloadExcel: "Download Excel",
    downloading: "Downloading",
    enroute: "Enroute",
    filter: "Filter",
    liveTracking: "Live tracking",
    loading: "Loading",
    logout: "Logout",
    next: "Next",
    optimizeAtt: "Optimize {0}",
    placeOrder: "Place Order",
    previous: "Previous",
    print: "Print",
    printAtt: "Print {0}",
    rate: "Rate",
    remove: "Remove",
    removing: "Removing",
    reschedule: "Reschedule",
    reset: "Reset",
    save: "Save",
    saveExcel: "Save excel",
    saveContact: "Save Contact",
    saving: "Saving",
    searchAtt: "Search for {0}",
    searchingAtt: "Searching {0}",
    select: "Select",
    send: "Send",
    setDefault: "Set Default",
    topUp: "Top Up",
    update: "Update",
    updating: "Updating",
    upload: "Upload",
    uploadAtt: "Upload {0}",
    uploading: "Uploading",
    uploadExcel: "Upload Excel",
    uploadProof: "Upload Proof",
    verify: "Verify",
  },
  general: {
    notAvailable: (ctx) => `${capitalize(ctx.named("msg"))} not available`,
    notFound: (ctx) => `${capitalize(ctx.named("msg"))} not found`,
    notSelected: (ctx) => `${capitalize(ctx.named("msg"))} not selected`,
    retrieving: "Retrieving {msg}",
  },
  login: {
    welcome: "Welcome Back",
    sendOutPackage: "Let's start sending out packages with our platform",
    enterEmail: "Enter Your Registered Email",
    enterPassword: "Enter Valid Password",
    signIn: "Sign In",
    or: "OR",
    changeHere: "Change here",
    forgotPassword: "Forgot account password",
    newToVite: "New to " + appName,
    signUp: "Sign up here",
    needHelp: "Need help?",
    clickHere: "Click here",
  },
  register: {
    letsStart: "Let's Get Started!",
    sendOutPackage: "Start sending more packages",
    getAccess: "Get access to the fastest and most reliable logistic service and platform <br> to help you with the deliveries",
    signUp: "Sign up",
    processRegister: "Registering account",
    successRegisterTitle: "Successfully Register Account",
    successRegisterBody: "Successfully register " + appName + " user account! You may now login into your account!",
    accountVerified: "Your account has been verified! Let's get ready and start sending out packages by clicking {0}",
    linkHere: "link here",
    invalidVerificationToken: "Invalid verification token",
    chooseRegistrationMethod: "Choose your registration method either using email or phone number. We’ll send an OTP code for verification!",
    accountExist: "Email or phone number had already been registered in our system",
    directToLogin: "You may login your account through the login page instead!",
    fillUserInformationTitle: "Fill User Information",
    fillUserInformationInstr: "Fill out your user information. You can edit the data after logging in to your account in User Setting.",
    countryChoice: "Your country setting determines the types of currency and services that you can select in " + appName + ".",
    setupCustomerAccountTitle: "Setup Customer Account",
    setupCustomerAccountInstr: "Before we move to the home page, let's setup your customer account first. <br/> Your customer info will be used as delivery information whenever you create order!",
    emailPurpose: "Email will be used to receive any notification and receipt for your delivery purchases.",
  },
  forgetPassword: {
    forgetAccountPassword: "Forget Your Account Password",
    sendEmail: 'Please input your registered email and we\'ll send an OTP code for verification',
    enterEmail: "Enter Your Registered Email",
    emailDoesntExist: "The email account is not valid or not registered. Please try again with a different account!",
    startRecovery: "Start Account Recovery",
    fillNewPasswordTitle: "Fill New Password",
    processChangingPassword: "Changing new password",
    haveAccount: "Already have an account",
    signIn: "Sign in here",
    or: "OR",
    successChangeTitle: "Successfully Change Password",
    successChangeMessage: "Successfully changed to new password! You may now login into your account using the new password!",
  },
  otp: {
    inputOTPCode: "Please input the 6-digit code verification that we’ve sent to <b>{0}</b>!",
    verifyOTP: "Verify OTP",
    notReceived: "Didn't receive any OTP code?",
    resendOTP: "Resend Code",
    sendingOTP: "Sending OTP number",
    verifyingOTP: "Verifying OTP number",
  },
  navMenuItem: {
    customer: "@:attribute.customer",
    driver: "@:attribute.driver",
    dashboard: "@:attribute.dashboard",
    createOrder: "@:action.create @:attribute.order",
    paymentOption: "@:attribute.paymentOption",
    bulkOrder: "@:attribute.bulkOrder",
    tool: "@:attribute.tool",
    settingResource: "@:attribute.settingResource",
    helpCenter: "@:attribute.helpCenter",
    account: "@:attribute.account",
    userSetting: "@:attribute.userSetting",
    contactUs: "@:action.contactUs",
  },
  dashboard: {
    overview: "Overview",
    orderList: "Order List",
    summary: "Summary",
    convenientDelivery: "Choose the most \n convenient delivery",
    createOrder: "Add new package",
    filterPickupDate: "Filter Pickup Date",
    myParcel: "My Parcels",
    clickDetail: "Click to view details",
    noDriver: "No assigned driver",
    noOrder: "No order found",
    downloadStatement: "Click on the download icon to save report statement of completed order(s) in PDF format",
    totalOrder: "Total Order",
    filterKeywordCaption: "Order number, pickup and delivery information, status, carrier, package size and type",
  },
  shippingDetail: {
    shippingDetail: "Shipping Detail",
    clickOrder: "Click one of the order to view shipping details",
    thankYouRating: "Thank you for your rating",
    pickupBefore: "Pickup before",
    pickupAt: "Pickup at",
    pickupAfter: "Pickup after",
    estimatedPickupBefore: "Estimated pickup before",
    contactQuery: "If you have any queries regarding your parcel collection, please refer to the Help Centre or send us an email via support@viamove.co",
    requestCollectionBefore: "Request collection before",
    estimatedDeliveryBefore: "Estimated delivery before",
    estimatedDeliveryAt: "Estimated delivery at",
    notAvailable: "Not available",
    packageNotAvailable: "@.capitalize:(attribute.package) not available",
    driverDetail: "Driver detail",
    rateOrder: "Rate Order",
    rateYourOrder: "Rate Your Order",
    selectStar: "Select star(s) to submit rating",
    selectPaperSize: "Select Paper Size",
    enrouteOrder: "Enroute Order",
    enrouteConfirmation: "You are about to enroute order. Please make sure driver has collected the parcel and is on the way to dropoff location",
    cancelOrder: "Cancel Order",
    cancelOrderAction: "Cancel Order | Cancel {count} Order(s)",
    viewRemainingOrder: "View remaining orders",
    cancelStatement: {
      confirmation: "You are about to cancel selected order",
      refund: "Upon cancellation, you will be given {0} as refund for this order",
      continue: "Do you want to continue cancellation?",
      remainingOrder: "You will not receive any refund unless all {base} base orders are cancelled.<br/> Remaining base order(s): {remaining}",
      noRefund: "There will be no refund for this order",
    },
  },
  setting: {
    accountInformation: "Account information",
    accountInformationCaption: "You can change your account's details and setting in this page",
    emailChangeWarning: "System will send email verification if email is changed. You will need to verify account to login",
    companyNameOptional: "Input N/A if company name is not available",
    changeCountryService: "Change country service",
    countryServiceCaption: "Create order using the service type within the selected country",
    changePassword: "Change password",
    changePasswordCaption: "Change password to keep your account safe",
    endSession: "End session",
    logoutCaption: "By ending your session, you will be logged out from the web portal and will be required to login to continue",
    stylingCaption: "Set application display to fit your style",
    addressBookCaption: "Address book stores your contact list and can be selected when you're creating orders",
    waybillCaption: "Customize waybill to fit your requirements",
    addLogoWaybill: "Add logo at top left corner of waybill",
    displayLogo: "Display logo",
    uploadNewLogo: "Upload new logo",
    selectImageFile: "Select image file by clicking here",
    sendSMSEnroute: "Send SMS to recipient when order is ENROUTED by delivery agent",
    hideSenderDetail: "Hide sender details in waybill/tracking (Only apply for Same Day and Next Day Premium Delivery)",
    inputNewEmailInstr: "Please input your new email and we’ll send an OTP code for verification!",
    inputNewPhoneNumberInstr: "Please input your new phone number and we’ll send an OTP code for verification!",
    useOrderReference: "Enable delivery collection by agent using customer's inputted reference number in order creation",
    linkedProvider: "Linked Provider",
    linkedProviderCaption: "Third party provider that are linked to your account for sign in process",
    unlinkConfirmation: "After logging out, please reset your password if your account is registered using third-party provider. Confirm unlink?"
  },
  addressBook: {
    searchAddress: "Find address using keyword (i.e postal code)",
    findAddressBook: "Find @:(attribute.addressBook)",
    searching: "You're searching for '{0}'",
    suggestionShown: "{0} address suggestion found",
    checkLocation: "Checking location availability",
    postalCodeAutoGenerate: "Postal code is auto generated from address suggestion",
    checkingLocation: "Checking location",
    invalidContactPostalCode: "Invalid postal code. Please remove and create new contact",
    removeConfirmation: "You are about to remove selected contact information. Do you want to continue?",
  },
  paymentMethod: {
    noSavedCard: "No credit card saved in for this account",
    topUpInstr: "Please select one of the topup options below",
    noTopUpPackage: "Top-up package not available. Please contact support for further inquiries",
    topUpSelectRequired: "Please select one of top up package list above",
    paymentMethodInstr: "Please select one of the payment method options below",
    proofOfTransferRequired: "Please upload your proof of transfer image file",
    addNewCard: "Add new card",
    addNewCardInstr: "Please input card number details below",
    uploadProofInstr: "Please upload proof of transfer by clicking here",
    orInputCardNumber: "Or input card number",
    setCardDefaultConfirmation: "You are about to change selected card as your preference card. Do you want to continue?",
    oneTwoWorkingDays: "1 - 2 working days",
    immediate: "Immediate",
    topUpAmountRequired: "Please enter top up amount",
    customTopUpAmountInstr: "or enter your top up amount here.",
    confirmTopUp: "Confirm TOP-UP",
    confirmTopUpInstr: "Please ensure the data is correct before submit.",
    topupAmountAvailability: "Custom amount only available for card payment.",
  },
  paymentTransaction: {
    transactionCaption: "All payment transactions are recorded in this list. Click the download icon to view the receipt of the selected transaction",
  },
  coupon: {
    transactionCaption:
      "Coupon can be received by purchasing wallet top-up in specific amount. These coupons can be applied as discount in order purchase. Please note that only 1 (one) coupon or promo code can be applied in a single order",
    available: "Available coupon(s)",
    used: "Used coupon(s)",
    offAmount: "{0} off",
    expired: "Expired coupon(s)",
    anyOrder: "Any order number",
    expiredAt: "Expire at",
  },
  topUpTransferRequest: {
    transactionCaption:
      'Wallet top-up that are paid using "@:(action.uploadProof)" method are recorded in this list! You can also check whether your request has been approved by our team. In the event that your request is rejected, please re-submit new request with correct information',
  },
  createOrder: {
    noDeliveryType: "No delivery service is available in selected country",
    oneToThreeDaysConfirmation: "1 - 3 Days Delivery service is {notGuaranteed}. For just $8, you can opt for a guaranteed Next Day Delivery (Premium). Do you still want to proceed?",
    notGuaranteed: "not a guaranteed",
    understandRisk: "I understand the risk",
    termConditionCaption: "By using our services, you agree to the following Terms and Conditions. Please read them carefully",
    acceptTermCondition: "I have read and agree to the Terms and Conditions",
    uploadExcelInstr: "Click to browse or drop your excel file here",
    validateCheckoutHeader: "Validate your data before checkout",
    validateCheckoutInstr: "Check all of the package details and contact information before placing order",
    packagingInstr:
      "Pack your parcels with proper materials and care help ensure your shipments arrive safely and intact. It is important to completely fill empty space within the box to avoid contents moving during transit which can cause damage to both contents and box",
    paymentMethodInstr: "Please select one of the available payment method shown in the options below",
    promoCodeInquiry: "Got a promo code?",
    singlePromoCode: "Please note that only one promo code can be applied per order",
    selectTypeSize: "Select package type and size",
    selectTimeSlot: "Select available timeslot",
    selectLocation: "Select location",
    selectLocationAndPackage: "Select location and define package",
    selectServiceType: "Select service type",
    selectVehicleType: "Select vehicle type",
    selectPackageCurrency: "Select the currency value of your packages",
    selectPricingRate: "Select available rates",
    selectRoundTripPackage: "Select round trip package type and size",
    timeSlotInstr: "Please choose the required service type and the available time slots",
    serviceChangeDateInstr: "In the event there are no service type shown, please change pickup date manually to the next available day",
    rateChangeDateInstr: "In the event there are no pricing rate shown, please change pickup date manually to the next available day",
    addonAvailable: "Some service type are available with addons that you can choose to include in the order",
    noServiceType: "No service type available. Please change to valid pickup date",
    noPriceRate: "No price rate available. Please change to valid pickup date",
    checkingDateAvailability: "Checking date availability",
    locationInstr: "Select pickup and dropoff location from our list of suggestions. You will be prompted to fill in contact information",
    contactInfoInstr: "It is recommended to include a mobile number as an automated SMS will be sent for a failed delivery",
    specialRequirement: "Please also note that special requirements will only be adhered to on a best effort basis",
    pinnedLocationInstr: "Please note that our system will calculate based on the pinned location to derive the pricing",
    checkoutPlaceOrder: "Checkout and place order",
    notesDriver: "Notes to driver",
    printParcelWaybill: "Please PRINT waybill and paste it on your parcels",
    writeOrderNumber: "You may also write order number on the parcels",
    printInvoiceWaybill: "Please PRINT 2x invoices, air waybill and paste it on the parcel",
    successCreate: "Successfully created order",
    selectFromSuggestion: "Select from address list",
    guaranteedAcceptance: "Guaranteed acceptance",
    noMinimumOrder: "No minimum order",
    availableDayRange: "Available from {0} to {1}",
    noExcessiveCredit: "No excessive credits top up needed",
    available24hour: "Available 24/7",
    wideSelectionVehicle: "Wide selection of vehicle types",
    distanceBasedRate: "Distance based rate",
    multipleDropoff: "Multiple dropoff points",
    pickupMinuteAfterAcceptance: "Pickup within {0} mins after acceptance, deliver within {1} mins (per stop)",
    minimumOrderCreated: "Minimum {0} orders per purchase",
    noGuaranteedDelivery: "Delivery non-guaranteed",
    questionInquiry: "Got any question?",
    vehicleFitParcel: "Make sure you have selected the correct vehicle type that can fit your parcel",
    inputSuggestionInstr: "You will have to select suggestion from each input field in order to proceed to the next step",
    assistPostalNotFound: " In the event of postal or city not found in our system, please livechat us for assistance",
    documentShipmentDesc: "Documents include legal, financial or business paperwork. Items with monetary value are NOT considered a document shipment",
    nonDocumentShipmentDesc: "Non-documents are goods, merchandise or commodities for personal or commercial purposes. ( require Invoice )",
    sendEmailAirWaybill: "System will send out an email attached with air way bill and/or invoice to sender once order is created",
    describeUniqueItem: "Describe each unique item in your shipment separately",
    dateBasedRate: "System will display pricing rate(s) based on the date and requirement that you have selected",
    rateNotIncludeTax: "The given rates are the estimated quote not inclusive of duties and taxes",
    printRequired: "You are required to print {0}",
    generateInvoiceInstr: "In the event where you do not have invoice, we can help you generate the invoice by simply select {0} and input all required fields",
    invoiceGenerateAfterCreate: "Invoice will be generated after completing order creation",
    customInvoiceRequired: "You'll need a customs invoice for this shipment",
    useOwnInvoice: "Use my Own Invoice",
    uploadBulkExcel: "Calculating excel data. This might take a while",
    checkoutBulk: "Checking out your orders. This might take a while",
  },
  reschedule: {
    confirmReschedule: "Confirm Reschedule",
    validateRescheduleInstr: "Please check and make sure the selected timeslot and schedule are correct before confirming reschedule",
  },
  tool: {
    calculateRate: "Calculate Rate",
    apiIntegration: "API Integration",
    connectWithUs: "Connect with us",
    rateInstr: "Get full details on delivery services, no go zone, and its rates by clicking the {0}",
    handbookInstr: "Learn more about web portal and its features that you might need by clicking the {0}",
    linkRightHere: "link right here",
    apiInstr: "Viamove API allows you to integrate our delivery services into your business workflow",
    apiAutomateFlow: "Viamove provides a collection of essential, lightweight and flexible endpoints allowing you to automate your fulfilment logistics workflow quickly and easily",
    apiContact: "Click the {0} to contact us for further inquiries",
  },
  notification: {
    viewAll: "View all notifications",
  },
  helpCenter: {
    groupDesc: "If you are looking for info about {0}, click here to show related topics that could help to answer your questions",
    clickLiveChat: "Click here to start live chat with us",
    howCanWeHelp: "Hello, how can we help you?",
    useKeywordArticle: "Use other keyword to find related article",
    notAnswer: "Not the answer you're looking for?",
  },
  driver:{
    downloadInstr: "Please download " + appName + " mobile app and sign up as delivery agent!"
  }
};

export default message;
